<template>
  <div id="6_1_address_container" class="vx-col sm:w-5/6 m-0">
    <div class="vx-row no-gutter items-center justify-center p-6">
      <forms-container :investor_id="InvestorId" :investor_status="InvestorStatus" :user_id="UserId"
        :moral-tabs="moralTabs" :pfae-tabs="pfaeTabs" save-btn-id="6_1_address_confirm_btn"
        @on-form-saved="saveDataForm" />
    </div>
  </div>
</template>

<script>
import FormsContainer from "@components/profile_shared/FormsContainer";

export default {
  props: ["onboardingStepData"],
  components: {
    FormsContainer
  },
  data() {
    return {
      pfaeTabs: ['address'],
      moralTabs: ['address'],
      errorMssg: null,
    };
  },
  methods: {
    async saveDataForm() {
      this.errorMssg = null;
      this.showLoading(true, "Guardando información...");
      try {
        let payload = {};
        await axios.post(
          "/api/v2/investor/" + this.InvestorId + "/saveOnboardingStep",
          payload
        );
        this.showLoading(false);
        this.$emit("updated", 1);
      } catch (e) {
        this.showLoading(false);
        this.showError(e);
      }
    },
    showError(e) {
      this.warn(e);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorMssg = err;
    },
  },
};
</script>

<style scoped>
/*
  vs-tabs envuelve su contenido en .con-vs-tabs/.con-slot-tabs con overflow:hidden
  (usado para la animación de deslizamiento entre tabs). Esto es lo que recorta el
  picker del v-select, no un problema de z-index. Como esta vista solo usa un tab
  ("address"), es seguro quitar el overflow aquí sin afectar la animación en otras
  vistas que sí usan varios tabs.
*/
::v-deep .con-vs-tabs,
::v-deep .con-vs-tabs .con-slot-tabs {
  overflow: visible;
}

/* Con un solo tab ("Domicilio") el header no aporta nada; se oculta y se deja solo el contenido. */
::v-deep .con-ul-tabs {
  display: none;
}
</style>